import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationOverrideVariationArgs, BackendVariation } from 'src/types/backend';

import { VARIATION_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation OverrideVariation($id: ID!, $selectedVariationId: ID!) {
    overrideVariation(id: $id, selectedVariationId: $selectedVariationId) {
      ...Variation
    }
  }
  ${VARIATION_FRAGMENT}
`;

type Variables = BackendMutationOverrideVariationArgs;
type Result = BackendVariation;

export const overrideVariation = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
